import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=58bcf6b2&"
import script from "./DateField.vue?vue&type=script&lang=ts&"
export * from "./DateField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports